module.exports = __webpack_public_path__ + "img/1012.eb6a234f.png";